'use server'

import { getServerSession } from 'next-auth'

import { authOptions } from '@/libs/auth'

export default async function getAuthToken(refresh = false) {
  const session = await getServerSession(authOptions)

  const authToken = refresh
    ? { token: session?.user?.refresh_token, error: session?.error }
    : session?.user?.access_token

  return authToken
}
